import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'
import Header from '../Header'

const Layout = (props) =>
  <div>
    <Header user={props.user} onLogout={props.onLogout} />
    <Container className='mt-4'>
      {props.children}
    </Container>
  </div>

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  onLogout: PropTypes.func,
  user: PropTypes.object
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js